import { GetAddressBookSuccessfulUploadProps } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

export const getAddressBookSuccessfulUploadTag = ({ options }: GetAddressBookSuccessfulUploadProps) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const addressBookSuccessfulUploadEvent = [
    {
      eventInfo: {
        eventName: 'address book upload',
        eventAction: options.eventType,
      },
    },
    {
      eventInfo: {
        eventName: 'address record upload',
        eventAction: options.statusMessage.toString(),
      },
    },
    {
      eventInfo: {
        eventName: 'file type',
        eventAction: options.fileType || '',
      },
    },
  ];

  const { modal, user } = getPODModalTag(
    'Address the Envelope - Recipient',
    addressBookSuccessfulUploadEvent,
    options.projectID,
  );

  return {
    modal,
    product,
    user,
  };
};
